/* theme.js — Foundation theme.
 * Cart functionality has been moved to assets/cart-drawer.js
 * which is loaded by sections/cart-drawer.liquid.
 */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------- Focus / dialog helpers ---------------- */
  function trapEscape(el, onClose) {
    function onKey(e) { if (e.key === 'Escape') { onClose(); } }
    el.addEventListener('keydown', onKey);
    return function () { el.removeEventListener('keydown', onKey); };
  }

  /* ---------------- Search panel ---------------- */
  (function search() {
    var panel = $('[data-search-panel]');
    if (!panel) return;
    var input = $('[data-search-input]', panel);
    function open() {
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      if (input) input.focus();
    }
    function close() {
      panel.hidden = true;
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-toggle]')) { open(); }
      else if (e.target.closest('[data-search-close]')) { close(); }
      else if (e.target === panel) { close(); }
    });
    trapEscape(document, function () { if (!panel.hidden) close(); });

    var form = $('[data-predictive]', panel);
    if (form && form.getAttribute('data-predictive') === 'true' && input) {
      var results = $('[data-predictive-results]', form);
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var term = input.value.trim();
        if (term.length < 2) { if (results) { results.hidden = true; } return; }
        timer = setTimeout(function () { runPredictive(term, results); }, 220);
      });
    }
  })();

  function runPredictive(term, container) {
    if (!container) return;
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        container.innerHTML = items.map(function (p) {
          return '<a class="search__result" href="' + p.url + '">' + escapeHtml(p.title) + '</a>';
        }).join('');
        container.hidden = items.length === 0;
      })
      .catch(function () {});
  }

  /* ---------------- Mobile menu ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    var nav = $('.mobile-nav');
    if (nav) nav.classList.toggle('is-open', !open);
  });

  /* ---------------- Cookie banner (UX only) ---------------- */
  (function cookies() {
    var banner = $('[data-cookie-banner]');
    if (!banner) return;
    var KEY = 'cookie-consent';
    var stored = safeGet(KEY);
    if (!stored) { banner.hidden = false; }
    banner.addEventListener('click', function (e) {
      if (e.target.closest('[data-cookie-accept]')) { decide('accepted', true); }
      else if (e.target.closest('[data-cookie-reject]')) { decide('rejected', false); }
    });
    function decide(value, allow) {
      safeSet(KEY, value);
      banner.hidden = true;
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent(allow, function () {});
        }
      } catch (err) {}
    }
  })();

  /* ---------------- Newsletter popup ---------------- */
  (function newsletterPopup() {
    var popup = $('[data-newsletter-popup]');
    if (!popup) return;
    var KEY = 'newsletter-popup-dismissed';
    var delaySeconds = Number(popup.getAttribute('data-delay')) || 5;
    var frequencyDays = Number(popup.getAttribute('data-frequency-days'));
    var dismissedAt = safeGet(KEY);
    if (dismissedAt) {
      var elapsedDays = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
      if (isNaN(frequencyDays) || frequencyDays <= 0 ? true : elapsedDays < frequencyDays) return;
    }
    setTimeout(open, delaySeconds * 1000);
    function open() {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = $('[data-newsletter-popup-close]', popup);
      if (closeBtn) closeBtn.focus();
    }
    function close(remember) {
      popup.hidden = true;
      document.body.style.overflow = '';
      if (remember) safeSet(KEY, String(Date.now()));
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-newsletter-popup-close]') && !popup.hidden) close(true);
    });
    trapEscape(document, function () { if (!popup.hidden) close(true); });
    if ($('[data-newsletter-success]', popup)) { open(); safeSet(KEY, String(Date.now())); }
  })();

  /* ---------------- License gate ---------------- */
  (function license() {
    var el = $('[data-license-status]');
    var cfgNode = $('[data-license-config]');
    var cfg = {};
    if (cfgNode) { try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { cfg = {}; } }
    var endpoint = cfg.endpoint || '';
    var key = cfg.key || '';
    var testMode = cfg.testMode !== false;
    if (testMode || !endpoint || !key) return;
    var CACHE = 'license-status', TTL = 6 * 60 * 60 * 1000;
    var cached = safeGet(CACHE);
    if (cached) {
      try { var c = JSON.parse(cached); if (Date.now() - c.t < TTL) { paint(c.s); return; } } catch (e) {}
    }
    fetch(endpoint + '?domain=' + encodeURIComponent(location.hostname), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { status: 'connection-error' }; })
      .then(function (d) { var s = d.status || 'invalid'; safeSet(CACHE, JSON.stringify({ s: s, t: Date.now() })); paint(s); })
      .catch(function () { paint('connection-error'); });
    function paint(status) { if (el) el.setAttribute('data-state', status); }
  })();

  /* ---------------- Utils ---------------- */
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function safeGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

})();